import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import MDBox from "../../MDBox";
import MDInput from "../../MDInput";
import Switch from "@mui/material/Switch";
import MDTypography from "../../MDTypography";

function ManualParams({ params, onChange }) {
  const toggleProofs = () => onChange({ ...params, proofs: !params.proofs });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MDBox display="flex" alignItems="center">
          <Switch checked={params.proofs || false} onChange={toggleProofs} />
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            onClick={toggleProofs}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            {(params.min || 0) > 0
              ? "La validation de cette étape requiert au moins " +
                params.min +
                " preuve" +
                (params.min > 1 ? "s" : "") +
                "."
              : "La validation de cette étape accepte de fournir des preuves."}
          </MDTypography>
        </MDBox>
      </Grid>
      <Grid item xs={6}>
        <MDBox>
          <MDInput
            type="number"
            label="Min"
            name="min"
            InputProps={{
              inputProps: {
                min: 0,
                max: params.max,
              },
            }}
            disabled={!params.proofs}
            value={params.min || 0}
            onChange={(e) => onChange({ ...params, min: e.target.value })}
            fullWidth
          />
        </MDBox>
      </Grid>
      <Grid item xs={6}>
        <MDBox>
          <MDInput
            type="number"
            label="Max"
            name="max"
            InputProps={{
              inputProps: {
                min: params.min || 0,
              },
            }}
            disabled={!params.proofs}
            value={params.max || ""}
            onChange={(e) => onChange({ ...params, max: e.target.value })}
            fullWidth
          />
        </MDBox>
      </Grid>
    </Grid>
  );
}
ManualParams.propTypes = {
  params: PropTypes.object,
  onChange: PropTypes.func,
};

export default ManualParams;
